
function getLabel(labels, modulename, formname, key) {
    if (labels) {
        return labels[modulename][formname][key];
    } else {
        return `${modulename}.${formname}.${key}`
    }
}


export default getLabel;